const URL = {
  ADD_CARD_INSIDE_COURSE: 'Card/CreateAndAddToCourse',
  CARD_PATCH: 'Card/Patch',
  PATCH_SETTING: 'Card/PatchSetting',
  CREATE_SETTING: 'Card/CreateSetting',
  REMOVE_SETTING: 'Card/RemoveCardSetting',
  ADD_CARD_SELECTION: 'Card/CreateSelection',
  PATCH_SELECTION: 'Card/PatchSelection',
  ADD_CARD_MEDIA: 'Card/AddCardMedia',
  ADD_CARD_LINK: 'Card/CreateLink',
  DELETE_CARD_MEDIA: 'Card/RemoveCardMedia',
  DELETE_CARD_LINK: 'Card/RemoveCardLink',
  DELETE_CARD_SELECTION: 'Card/RemoveCardSelection',
  GET_SERTIFIER_DELIVERIES: 'Integration/GetSertifierDeliveries',
  ADD_CARD_SELECTIONS: 'Card/CreateSelections',
  ADD_CARD: 'Card',
  DELETE_SECTION: 'section/{id}',
  GET_CARD: 'Card/{id}',
  DUPLICATE_CARD: 'Card/Duplicate',
  PUBLISH_CARD: 'card/{id}/publish',
  UNPUBLISH_CARD: 'card/{id}/unpublish',
  DISCARD_CARD_CHANGES: 'card/{id}/discard-changes',
}

export default URL
